<div class="owner-card">
  <!-- Green check icon -->
  <div class="flex mb-1 gap-1">
    <!-- <i class="fa-solid fa-circle-check text-dc-dark-green h-5 w-5"></i> -->
    @if(owner?.showRequiredFieldError && hasMissingRequiredFields(owner)){
      <img src="/icons/svg/warning.svg" class="status-icon" />
      <span class="text-dc-orange">
        {{ "VALIDATION_MSG.FILL_REQUIRED_FIELDS" | translate }}
      </span>
    }@else {
       <img src="/icons/svg/card-success.svg" class="status-icon" />
    }
  </div>

  <!-- Owner Info -->
  <div class="mb-5">
    <h2>{{ owner.nameEn ? owner.nameEn : owner.companyNameEn }}</h2>
    <!-- <label class="mb-1">{{ getLookupsNames("roles", owner.roles) }}</label> -->
    <label>
      {{ "OWNER_FORM.NATIONALITY" | translate }}
    </label>
    <span>
      {{ owner.nationality }}
    </span>

    <label>{{ "OWNER_FORM.MOBILE" | translate }}</label>
    <span>{{ owner.mobile }}</span>

    <label>{{ "OWNER_FORM.EMAIL" | translate }}</label>
    <span>{{ owner.email }}</span>

    <label class="w-full">
      <span>{{ "OWNER_FORM.ROLE_SIGNATORY" | translate }}</span>
      @if(showAction){
      <i
        class="fas fa-pencil text-dc-navy cursor-pointer hover:text-dc-orange ltr:float-right rtl:float-left"
        (click)="isEditingSignatory = !isEditingSignatory"
      >
      </i>
      }
    </label>

    <ng-container>
      @if(!isEditingSignatory){
      <span>
        {{ owner.authorisedSignatory == "Y" ? "Yes" : "No" }}
      </span>
      } @if(isEditingSignatory && showAction){
      <select
        class="w-full border border-gray-300 bg-white px-3 py-2 text-sm text-dc-navy focus:outline-none"
        [(ngModel)]="owner.action"
        (change)="updateOwnerAction(owner)"
      >
        <!-- <option [ngValue]="''" disabled>
          {{ "SELECT" | translate }}
        </option> -->
        <option value="Add">
          {{ "MANAGE_SIGNATORIES.SIGNATORY_ACTION_ADD" | translate }}
        </option>
        <option value="Remove">
          {{ "MANAGE_SIGNATORIES.SIGNATORY_ACTION_REMOVE" | translate }}
        </option>
        <option value="No Change">
          {{ "MANAGE_SIGNATORIES.SIGNATORY_ACTION_NO_CHANGE" | translate }}
        </option>
      </select>
      }
    </ng-container>
    
    <!-- Actions -->
    <div class="flex items-center gap-4 text-sm mt-7">
       @if(((isNewSignatory(owner) || owner?.isNewSignatory) || hasMissingRequiredFields(owner)) && showAction){
      <a class="card-action-edit-remove" (click)="editDetail(owner)"
        >{{ "EDIT_DETAILS" | translate }}
      </a>
      
      @if((isNewSignatory(owner) || owner?.isNewSignatory) && showAction){
      <a class="card-action-edit-remove" (click)="remove(owner)"
        >{{ "REMOVE" | translate }}
      </a>
      }
      }@else {
      <a class="card-action-edit-remove" (click)="viewDetail(owner)"
        >{{ "BUTTONS.VIEW_DETAILS" | translate }}
      </a>
      }
    </div>
  </div>
  <!-- Bottom green corner -->
  <div class="dc-card-corner-green"></div>   
</div>
